import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { actionCreators } from "../redux/BrandLeaderBoardSagas";
import MonthPicker from "../../../components/reactMonthPicker/reactMonthPicker";

const DatePicker = () => {
  const {
    selectedRequestDates: { startDate, endDate },
    currentUser: { calendarStartDate, calendarEndDate }
  } = useSelector((state) => state.brandLeaderboard);

  const dispatch = useDispatch();
  return (
    <MonthPicker
      startDate={startDate}
      endDate={endDate}
      calendarStartDate={calendarStartDate}
      calendarEndDate={calendarEndDate}
      updateDates={(startDate, endDate) =>
        dispatch(actionCreators.updateDates({ startDate, endDate }))
      }
    />
  );
};

export default DatePicker;
